import { render, staticRenderFns } from "./TaskMoneyConfig.vue?vue&type=template&id=30592f32&"
import script from "./TaskMoneyConfig.vue?vue&type=script&lang=js&"
export * from "./TaskMoneyConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports